import * as React from 'react';

/**
 * Forked from https://github.com/NeoRaider/react-multi-split-pane
 * MIT License
 */

export interface PaneProps {
   size: number;
   sizeIsPixelSize: boolean;

   minSize: number;
   maxSize: number;

   split: 'horizontal' | 'vertical';
   className?: string;

   forwardRef: React.Ref<HTMLDivElement>;

   children: React.ReactNode;
}

const baseStyle: React.CSSProperties = {
   position: 'relative',
   outline: 'none',
   border: 0,
   overflow: 'hidden',
   display: 'flex',
   flexBasis: 'auto',
};

export const Pane = React.memo(({ size, sizeIsPixelSize, minSize, maxSize, split, className, forwardRef, children }: PaneProps) => {

   const style: React.CSSProperties = React.useMemo(() => {

      const style = {
         ...baseStyle,
         flexGrow: (sizeIsPixelSize) ? undefined : size,
         flexShrink: (sizeIsPixelSize) ? undefined : size,
      };

      if (split === 'vertical') {
         style.width = (sizeIsPixelSize) ? ((size<0) ? 'max-content' : size+'px') : 0;
         style.height = '100%';
         style.minWidth = minSize;
         style.maxWidth = (maxSize >= 0) ? maxSize : undefined;
      } else {
         style.width = '100%';
         style.height = (sizeIsPixelSize) ? ((size<0) ? 'max-content' : size+'px') : 0;
         style.minHeight = minSize;
         style.maxHeight = (maxSize >= 0) ? maxSize : undefined;
      }
      return style;
   }, [size, sizeIsPixelSize, minSize, maxSize, split]);

   const classes = ['Pane', split, className].join(' ');

   return (
      <div className={classes} style={style} ref={forwardRef}>
         {children}
      </div>
   );
});
Pane.displayName = 'Pane';
